import angular from "angular";
import chatModule from '../chatModule';

function dialog($window, $compile, $templateCache, $filter, chatUtility, 
    chatClientStorageUtilityService, localStorageService, messageService,
    resources, gameService, gameLayout, $log) {
    "ngInject";
    return {
        restrict: "A",
        scope: {
            dialogData: "=",
            chatLibrary: "=",
            chatUser: "=",
            closeDialog: "&",
            sendInvite: "&",
        },
        link: function (scope, element, attrs) {
            var limitMemberDisplay = chatUtility.dialogLayout.limitMemberDisplay;
            var intervalCount = 0;

            var loadScope = function () {
                scope.isOverLoaded();
                scope.dialogData.currentUserId = scope.currentUserId;
                var dialogTemplate = resources.templates.dialogTemplate;
                var groupDialogTemplate = resources.templates.groupDialogTemplate;
                var newGroupTemplate = resources.templates.createChatGroupTemplate;
                switch (scope.dialogData.dialogType) {
                    case chatUtility.dialogType.CHAT:
                        var userId;
                        angular.forEach(scope.dialogData.userIds, function (id) {
                            if (id !== scope.chatLibrary.userId) {
                                userId = id;
                            }
                        });
                        scope.dialogLayout.title = !scope.chatLibrary.friendsDict[userId] ? scope.dialogData.title : scope.chatLibrary.friendsDict[userId].name;
                        scope.dialogLayout.templateUrl = dialogTemplate;
                        scope.dialogLayout.scrollbarElm = chatUtility.getScrollBarSelector(scope.dialogData, chatUtility.scrollBarType.MESSAGE);
                        scope.dialogData.name = !scope.chatLibrary.friendsDict[userId] ? scope.dialogData.title : scope.chatLibrary.friendsDict[userId].name;
                        scope.dialogData.nameLink = scope.chatLibrary.friendsDict[userId] ? scope.chatLibrary.friendsDict[userId].profileUrl : "";
                        break;
                    case chatUtility.dialogType.GROUPCHAT:
                        scope.dialogLayout.templateUrl = groupDialogTemplate;
                        scope.dialogLayout.limitMemberDisplay = limitMemberDisplay;
                        scope.dialogLayout.scrollbarElm = chatUtility.getScrollBarSelector(scope.dialogData, chatUtility.scrollBarType.MESSAGE);
                        scope.dialogData.name = scope.dialogData.title;
                        break;
                    case chatUtility.dialogType.NEWGROUPCHAT:
                        scope.dialogLayout.title = scope.dialogData.title;
                        scope.dialogLayout.templateUrl = newGroupTemplate;
                        break;
                }

                scope.updateDialogStyle();
            }

            var destroyChildScope = function () {
                var validTimeStamp;
                if (scope.chatLibrary && scope.chatLibrary.dialogScopeLib[scope.dialogData.id]) {
                    validTimeStamp = scope.chatLibrary.dialogScopeLib[scope.dialogData.id];
                }
                if (scope.$$childHead && scope.$$childHead != null && scope.$$childHead.timeStamp === validTimeStamp) {
                    scope.$$childHead.$destroy();
                }

            }

            var loadTemplate = function () {
                if (scope.dialogLayout.IsdialogContainerVisible || element.find(".dialog-container")) {
                    scope.dialogLayout.IsdialogContainerVisible = false;
                    element.empty();
                }
                var dialogTemplate = angular.element($templateCache.get(scope.dialogLayout.templateUrl));

                destroyChildScope();

                var newScope = scope.$new();
                var timeStamp = Date.now();
                if (scope.chatLibrary) {
                    scope.chatLibrary.dialogScopeLib[scope.dialogData.id] = timeStamp;
                }
                newScope.timeStamp = timeStamp;
                var lfn = $compile(dialogTemplate);
                element.append(dialogTemplate);
                lfn(newScope);
            }

            var isTextSelected = function () {
                var text = "";
                if (angular.isDefined(window.getSelection)) {
                    text = window.getSelection().toString();
                } else if (angular.isDefined(window.document.selection) && window.document.selection.type === "Text") {
                    text = window.document.selection.createRange().text;
                }
                return text.length > 0;
            }

            var updatePosition = function (list) {
                var layoutId = scope.dialogData.layoutId;
                var idOfDialog = "#" + layoutId;
                var chatLayout = scope.chatLibrary.chatLayout;
                var dialogElm = angular.element(document.querySelector(idOfDialog)).find(".dialog-container");
                var widthOfChatContainer = chatLayout.widthOfChat;
                var widthOfDialog = chatLayout.widthOfDialog + chatLayout.spaceOfDialog;
                var indexPositionOfDialog = list.indexOf(layoutId);
                var library = scope.chatLibrary;
                var widthOfDialogs = chatUtility.calculateRightPosition(library, indexPositionOfDialog);

                var right = +widthOfChatContainer + widthOfDialogs + chatLayout.spaceOfDialog;
                // get current window size
                var widthOfWindow = $window.innerWidth;
                if (widthOfWindow < right + widthOfDialog) {
                    var zIndex = +chatLayout.defaultChatZIndex + 1;
                    dialogElm.css("z-index", zIndex);
                } else {
                    var zIndex = +chatLayout.defaultChatZIndex + indexPositionOfDialog;
                    chatUtility.updateDialogsPosition(library);
                    dialogElm.css("z-index", zIndex);
                }
                dialogElm.addClass("dialog-visible");
            }

            var saveDialogStatusInCookie = function () {
                chatClientStorageUtilityService.updateStorage(chatClientStorageUtilityService.storageDictionary.dialogIdList, scope.chatLibrary.dialogIdList, scope.chatLibrary.cookieOption);
                chatClientStorageUtilityService.updateStorage(chatClientStorageUtilityService.storageDictionary.dialogDict, scope.chatLibrary.dialogDict, scope.chatLibrary.cookieOption);
            }

            scope.saveIntoDialogsLayout = function () {
                const { layoutId } = scope.dialogData;
                if (scope.dialogLayout && scope.dialogLayout.layoutId === layoutId) {
                    scope.chatLibrary.dialogsLayout[layoutId] = scope.dialogLayout;
                    chatClientStorageUtilityService.updateStorage(chatClientStorageUtilityService.storageDictionary.dialogsLayout, scope.chatLibrary.dialogsLayout, scope.chatLibrary.cookieOption);
                }
            }

            var isFriendNonMember = function (friendId) {
                var currentUserPosition = angular.isDefined(scope.dialogData.userIds) ? scope.dialogData.userIds.indexOf(friendId) : -1;
                var selectedUserPosition = angular.isDefined(scope.dialogData.selectedUserIds) ? scope.dialogData.selectedUserIds.indexOf(friendId) : -1;
                return currentUserPosition < 0 && selectedUserPosition < 0;
            }

            // dialogLibrary is used for chat dialogs in each tab status
            var getDialogLibrary = function () {
                scope.dialogLibrary = !localStorageService.getLocalStorage(scope.chatLibrary.dialogLocalStorageName) ? {} : localStorageService.getLocalStorage(scope.chatLibrary.dialogLocalStorageName);
            }

            var getActiveStatusFromLocalStorage = function () {
                return scope.dialogLibrary
                    && scope.dialogLibrary[scope.dialogData.layoutId]
                    && scope.dialogLibrary[scope.dialogData.layoutId].active;
            }

            var getInactiveStatusFromLocalStorage = function () {
                return scope.dialogLibrary
                    && scope.dialogLibrary[scope.dialogData.layoutId]
                    && !scope.dialogLibrary[scope.dialogData.layoutId].active;
            }

            var init = function () {
                scope.dialogData.friendIds = scope.chatLibrary.friendIds ? scope.chatLibrary.friendIds.slice() : [];
                scope.dialogMessages = [];
                scope.dialogType = Object.assign({}, chatUtility.dialogType);
                scope.memberStatus = Object.assign({}, chatUtility.memberStatus);
                scope.dialogBannerTypes = Object.assign({}, chatUtility.dialogBannerTypes);
                scope.dialogLayout = angular.isDefined(scope.chatLibrary.dialogsLayout[scope.dialogData.layoutId]) ? scope.chatLibrary.dialogsLayout[scope.dialogData.layoutId] : angular.copy(chatUtility.dialogLayout);
                scope.dialogLayout.layoutId = scope.dialogData.layoutId;
                scope.toastLayout = {
                    isEnabled: scope.dialogLayout.isMembersOverloaded,
                    timeout: scope.dialogLayout.memberDisplay.timeoutToast
                }
                scope.dialogLayout.defaultStyle = {};
            }

            //// ----------------------------------- PUBLIC ---------------------------------
            scope.updateDialogStyle = function () {
                chatUtility.updateDialogStyle(scope.dialogData, scope.dialogLayout, scope.chatLibrary);
            }

            scope.updateFriends = function (data) {
                // friend Ids library exist
                var candidateFriendIds = [];
                if (!data) {
                    const friendIds = scope.chatLibrary.friendIds.slice();
                    angular.forEach(friendIds, function (friendId) {
                        // remove existing user from friendIs;
                        if (isFriendNonMember(friendId)) {
                            candidateFriendIds.push(friendId);
                        }
                    });
                    scope.dialogData.friendIds = candidateFriendIds;
                } else {
                    // get the friends or more data;
                    var friends = chatUtility.sortFriendList(scope.chatLibrary, data);
                    if (friends) {
                        friends.forEach(function (friend) {
                            if (isFriendNonMember(friend.id)) {
                                candidateFriendIds.push(friend.id);
                            }
                            if (!scope.chatLibrary.friendsDict[friend.id]) {
                                scope.chatLibrary.friendsDict[friend.id] = friend;
                            }
                        });
                        scope.dialogData.friendIds = candidateFriendIds;
                    }
                }
            }

            // verify number of member is overloaded
            scope.isOverLoaded = function () {
                if (angular.isUndefined(scope.dialogData.selectedUserIds)) {
                    scope.dialogData.selectedUserIds = [];
                    scope.dialogData.selectedUsersDict = {};
                }
                if (scope.dialogData.dialogType !== chatUtility.dialogType.FRIEND) {
                    if (scope.dialogData.dialogType === chatUtility.dialogType.NEWGROUPCHAT) {
                        scope.dialogData.numberOfSelected = scope.dialogData.selectedUserIds.length;
                    } else if (scope.dialogData.dialogType === chatUtility.dialogType.CHAT) {
                        scope.dialogData.numberOfSelected = scope.dialogData.userIds.length + scope.dialogData.selectedUserIds.length; // decrease both user in 1:1
                    } else {
                        scope.dialogData.numberOfSelected = scope.dialogData.userIds.length + scope.dialogData.selectedUserIds.length - 1; // decrease myself 
                    }
                    scope.dialogLayout.isMembersOverloaded = (scope.dialogData.numberOfSelected >= scope.chatLibrary.quotaOfGroupChatMembers) ? true : false;
                }
            }

            scope.dialogData.selectedUserIds = [];
            scope.dialogData.selectedUsersDict = {};
            // used for legacy select friends
            scope.selectFriends = function (userId) {
                var position = scope.dialogData.selectedUserIds.indexOf(userId);
                if (position < 0 && !scope.dialogLayout.isMembersOverloaded) { // not existing
                    scope.dialogData.selectedUserIds.push(userId);
                    scope.dialogData.selectedUsersDict[userId] = angular.copy(scope.chatLibrary.friendsDict[userId]);
                } else if (position > -1) {
                    scope.dialogData.selectedUserIds.splice(position, 1);
                    delete scope.dialogData.selectedUsersDict[userId];
                }
                scope.dialogData.searchTerm = "";
                scope.isOverLoaded();
            }

            // reskin
            scope.isNumberOfMemberOverloaded = function () {
                var numberOfSelectedUsers = scope.dialogData.selectedUserIds ? scope.dialogData.selectedUserIds.length : 0;
                var numberOfExistingUsers = 0;
                if (scope.dialogData.userIds) {
                    numberOfExistingUsers = scope.dialogData.dialogType === chatUtility.dialogType.CHAT
                        ? scope.dialogData.userIds.length : scope.dialogData.userIds.length - 1;
                }
                if (numberOfSelectedUsers + numberOfExistingUsers >= scope.chatLibrary.quotaOfGroupChatMembers) {
                    scope.dialogLayout.isMembersOverloaded = true;

                    if (scope.dialogLayout.details.isEnabled || scope.dialogData.dialogType === chatUtility.dialogType.NEWGROUPCHAT) {
                        scope.toastLayout.isNeeded = true;
                        if (!scope.toastLayout.text) {
                            scope.toastLayout.text = scope.dialogLayout.memberDisplay.toastText(scope.chatLibrary.quotaOfGroupChatMembers);
                        }
                    }
                    return true;
                }
                return false;
            }

            scope.toggleFriendSelection = function (userId, event) {
                if (event) {
                    event.preventDefault();
                }
                var position = scope.dialogData.selectedUserIds.indexOf(userId);
                if (position < 0 && !scope.isNumberOfMemberOverloaded()) { // not existing
                    scope.dialogData.selectedUserIds.push(userId);
                    scope.dialogData.selectedUsersDict[userId] = angular.copy(scope.chatLibrary.friendsDict[userId]);
                    scope.dialogData.selectedUsersDict[userId].isSelected = true;
                } else if (position > -1) {
                    scope.dialogData.selectedUserIds.splice(position, 1);
                    delete scope.dialogData.selectedUsersDict[userId];
                }
                scope.dialogData.searchTerm = "";
                scope.isOverLoaded();
            }

            scope.toggleDialogContainer = function () {
                scope.dialogLayout.collapsed = !scope.dialogLayout.collapsed;
                scope.toggleDialogFocusStatus(!scope.dialogLayout.collapsed);
                scope.saveIntoDialogsLayout();
                chatUtility.updateDialogsPosition(scope.chatLibrary);
            }

            scope.toggleDialogFocusStatus = function (status) {
                if (status) {
                    chatUtility.updateFocusedDialog(scope.chatLibrary, scope.dialogData.layoutId);
                    messageService.markMessagesAsRead(scope.dialogData, scope.chatLibrary.shouldRespectConversationHasUnreadMessageToMarkAsRead);
                }
                scope.dialogLayout.hasFocus = status;
                if (status && scope.dialogLayout.active) {
                    scope.markInactive();
                }

                // can not be input box selected
                // can not be in app
                // can not be minimized status
                var focusMeEnabled = status
                    && !isTextSelected()
                    && !scope.dialogLayout.collapsed
                    && !scope.dialogLayout.renameEditor.isEnabled;
                scope.dialogLayout.focusMeEnabled = focusMeEnabled;
                scope.saveIntoDialogsLayout();
                return false;
            }

            scope.getTitle = function (activeType) {
                var title;
                var username;
                var message = scope.dialogData.chatMessages;
                if (message && message.length > 0) {
                    var userId = message[0].senderTargetId;
                    if (!userId) { // need to remove this feature 
                        return false;
                    }
                    username = scope.chatLibrary.friendsDict[userId].name;
                }
                else {
                    username = scope.dialogData.initiator.name;
                }
                title = $filter("formatString")(chatUtility.chatLayout.defaultTitleForMessage, { 'userName': username });
                scope.title = title;
            }

            scope.changeTitle = function () {
                $window.document.title = intervalCount % 2 === 0 ? scope.title : scope.chatLibrary.currentTabTitle;
                intervalCount++;
            }

            scope.markInactive = function () {
                if (scope.dialogLayout.active) {
                    scope.dialogLayout.active = false;

                    getDialogLibrary();
                    if (getActiveStatusFromLocalStorage()) {
                        $log.debug(" --------------- markInactive -------------- set into local storage");
                        if (angular.isUndefined(scope.dialogLibrary[scope.dialogData.layoutId])) {
                            scope.dialogLibrary[scope.dialogData.layoutId] = {};
                        }
                        scope.dialogLibrary[scope.dialogData.layoutId].active = false;
                        scope.dialogLibrary[scope.dialogData.layoutId].played = false;
                        localStorageService.setLocalStorage(scope.chatLibrary.dialogLocalStorageName, scope.dialogLibrary);
                    }
                }
            }

            scope.markActive = function (activeType) {
                getDialogLibrary();

                if (angular.isUndefined(scope.dialogLibrary[scope.dialogData.layoutId])) {
                    scope.dialogLibrary[scope.dialogData.layoutId] = {};
                }
                scope.dialogLibrary[scope.dialogData.layoutId].active = true;
                scope.dialogLibrary[scope.dialogData.layoutId].played = false;
                localStorageService.setLocalStorage(scope.chatLibrary.dialogLocalStorageName, scope.dialogLibrary);

                if (scope.dialogLayout.collapsed || scope.chatLibrary.chatLayout.focusedLayoutId !== scope.dialogData.layoutId) {
                    scope.dialogLayout.active = true;
                    if (scope.dialogLayout.focusMeEnabled) {
                        scope.dialogLayout.focusMeEnabled = false;
                    }
                } else {
                    messageService.markMessagesAsRead(scope.dialogData);
                }
            }

            scope.handleLocalStorage = function (event) {
                if (event.key === scope.chatLibrary.dialogLocalStorageName) {
                    getDialogLibrary();
                    if (scope.dialogLayout.active && getInactiveStatusFromLocalStorage()) {
                        scope.markInactive();
                    }
                }
            }

            scope.checkNewGenerationDialogStatus = function () {
                if (scope.dialogData.isRenameEditorNeeded) {
                    if (scope.dialogLayout.focusMeEnabled) {
                        scope.dialogLayout.focusMeEnabled = false; // turn off dialog message input auto focus
                    }
                    scope.dialogData.isRenameEditorNeeded = false;
                    scope.dialogLayout.renameEditor.isEnabled = true;
                    scope.dialogLayout.renameEditor.hasFocus = true;
                }
            }


            scope.getRecentGames = function () {
                if (!scope.chatLibrary.isGetRecentGamesCalled) {
                    if (!scope.chatLibrary.isGetRecentGamesCalled) {
                        scope.chatLibrary.isGetRecentGamesCalled = true;
                    }
                    gameService.getRecentGame()
                        .then(function success(result) {
                            if (result && result.length > 0) {
                                var place = result[0];
                                var placeId = place.placeId;
                                var placeDetailsData = {};
                                placeDetailsData[placeId] = place;
                                gameService.buildPlacesLibrary(scope.chatLibrary, placeDetailsData);
                                scope.chatLibrary.placesLibrary[place.placeId].buttonLayoutForMe = Object.assign({}, gameLayout.playButtons.play);
                                scope.chatLibrary.myRecentPlaceId = placeId;
                                var universeIds = [place.universeId];
                                gameService.getGameIcons(universeIds)
                                    .then(function success(gameIcons) {
                                        if (gameIcons) {
                                            var gameIcon = gameIcons[0];
                                            scope.chatLibrary.placesLibrary[placeId].gameIconUrl = gameIcon.imageUrl;
                                        }
                                    });
                            }
                        });
                }
            }
            scope.search = function (item) {
                const searchTerm = scope.dialogData.searchTerm;
                if (!searchTerm) {
                    return true;
                }
                const { name, contact } = item;
                const searchTermLowerCase = searchTerm.toLowerCase();

                return name.toLowerCase().indexOf(searchTermLowerCase) !== -1
                    || (contact && contact.toLowerCase().indexOf(searchTermLowerCase) !== -1);
            };
            //// ----------------------------------- CODE TO RUN --------------------------------
            init();
            scope.isOverLoaded();

            scope.$watch(function () {
                return scope.chatLibrary.dialogDict;
            }, function (newValue, oldValue) {
                if (angular.isDefined(newValue) && angular.isDefined(newValue[scope.dialogData.layoutId])) {
                    //$log.debug("------ watch dialogDict ----- update on scope.dialogData.layoutId : " + scope.dialogData.layoutId);
                    var layoutId = scope.dialogData.layoutId;
                    var chatLibrary = scope.chatLibrary;
                    var position = chatLibrary.dialogIdList.indexOf(layoutId);
                    var currentDialog = newValue[layoutId];
                    var previousDialog = oldValue[layoutId];

                    if (!previousDialog || currentDialog.isUpdated) {
                        if (angular.isDefined(scope.chatLibrary.dialogsLayout[scope.dialogData.layoutId])) {
                            scope.dialogLayout = scope.chatLibrary.dialogsLayout[scope.dialogData.layoutId];
                        } else if (angular.isUndefined(scope.dialogLayout)) {
                            scope.dialogLayout = angular.copy(chatUtility.dialogLayout);
                        } else if (currentDialog.updateStatus === chatUtility.dialogStatus.INIT && scope.dialogLayout) {
                            scope.dialogLayout.renameEditor = Object.assign({}, chatUtility.dialogLayout.renameEditor);
                        }

                        currentDialog.isUpdated = false;
                        switch (currentDialog.updateStatus) {
                            case chatUtility.dialogStatus.REPLACE:
                                if (position > -1) {
                                    // uncollapse tab only if replacing chat tab with a tab being opened from the minimized chat section
                                    if (scope.dialogLayout.collapsed) {
                                        scope.dialogLayout.collapsed = false;
                                    }
                                    // this prevents the uncollapsing from occurring
                                    // on a previously restored (REPLACE status) dialog that has been collapsed
                                    currentDialog.updateStatus = chatUtility.dialogStatus.INIT;
                                    scope.toggleDialogFocusStatus(true);
                                }
                            case chatUtility.dialogStatus.INIT:
                                if (position > -1) { // only load template when it is part of dialogIdList which is the list of open dialogs
                                    // Whenever the auto open dialog happens, dialog will be not set focus as default
                                    if (scope.dialogLayout.focusMeEnabled === currentDialog.autoOpen) {
                                        scope.dialogLayout.focusMeEnabled = !currentDialog.autoOpen;
                                        if (!currentDialog.autoOpen) {
                                            messageService.markMessagesAsRead(scope.dialogData);
                                        }
                                    }
                                    scope.checkNewGenerationDialogStatus();
                                    loadScope();
                                    loadTemplate();
                                }
                                break;
                            case chatUtility.dialogStatus.MINIMIZE:
                                loadScope();
                                if (scope.chatLibrary.minimizedDialogIdList.indexOf(layoutId) < 0) {
                                    scope.chatLibrary.minimizedDialogIdList.push(layoutId);
                                    scope.chatLibrary.minimizedDialogData[layoutId] = scope.dialogData;
                                }
                                element.empty();
                                break;
                            case chatUtility.dialogStatus.REFRESH:
                                loadScope();
                                currentDialog.updateStatus = chatUtility.dialogStatus.INIT;
                                break;
                        }

                        if (position === 0) {
                            scope.getRecentGames();
                        }
                    }

                    saveDialogStatusInCookie();
                    scope.saveIntoDialogsLayout();
                    if (position > -1) {
                        updatePosition(chatLibrary.dialogIdList);

                        if (currentDialog.markAsActive) {
                            scope.markActive(currentDialog.activeType);
                            currentDialog.markAsActive = false;
                        }
                    }
                }
            }, true);

            scope.$on("Roblox.Chat.MarkDialogInactive", function (event, args) {
                if (args.layoutId === scope.dialogData.layoutId) {
                    scope.markInactive();
                }
            });

            localStorageService.listenLocalStorage(scope.handleLocalStorage);
        }
    }
};

chatModule.directive("dialog", dialog);

export default dialog;